import React from "react";
import type { AccurateModuleDefinition } from "../../types/accuratePosting";

interface PostingFormProps {
  modules: AccurateModuleDefinition[];
  moduleType: string;
  number: string;
  isLoading: boolean;
  onModuleChange: (moduleType: string) => void;
  onNumberChange: (number: string) => void;
  onLookup: () => void;
}

const PostingForm: React.FC<PostingFormProps> = ({
  modules,
  moduleType,
  number,
  isLoading,
  onModuleChange,
  onNumberChange,
  onLookup,
}) => (
  <form
    className="grid gap-4 rounded border bg-gray-50 p-4 md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)_auto] md:items-end"
    onSubmit={(event) => {
      event.preventDefault();
      onLookup();
    }}
  >
    <label className="flex flex-col gap-1 text-sm font-medium text-gray-700">
      Module
      <select
        aria-label="Module"
        className="rounded border border-gray-300 bg-white p-2 font-normal"
        value={moduleType}
        onChange={(event) => onModuleChange(event.target.value)}
        disabled={isLoading || modules.length === 0}
      >
        <option value="">Select module</option>
        {modules.map((module) => (
          <option key={module.moduleType} value={module.moduleType}>
            {module.moduleLabel || module.moduleType}
          </option>
        ))}
      </select>
    </label>
    <label className="flex flex-col gap-1 text-sm font-medium text-gray-700">
      Transaction number
      <input
        aria-label="Transaction number"
        className="rounded border border-gray-300 p-2 font-normal"
        value={number}
        onChange={(event) => onNumberChange(event.target.value)}
        placeholder="Enter transaction number"
        disabled={isLoading}
      />
    </label>
    <button
      type="submit"
      className="rounded bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-400"
      disabled={isLoading || !moduleType || !number.trim()}
    >
      {isLoading ? "Loading..." : "Search"}
    </button>
  </form>
);

export default PostingForm;
